'use strict';

var _Media = require('./Media');

var _Media2 = _interopRequireDefault(_Media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove in the next major release.
_Media2.default.Media = _Media2.default; /* eslint-env node */


module.exports = _Media2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-media/index.js
// module id = 288
// module chunks = 0